/**
 * Which quote editor the RC app uses, for EVERY store (DAO Watches stores
 * included): the no-pop-up quote workspace (QuoteRoster + QuoteWorkspace) by
 * default, or the original quote list + pop-up (QuoteList + Quote modal).
 *
 * One app-wide switch, set at build time: VITE_QUOTE_WORKSPACE=off brings the
 * original back for everyone. The per-store `quote_product_pricing` flag no
 * longer picks the editor; it still drives the backend's buying-price
 * fallbacks and the original pop-up's fields.
 */
export const quoteWorkspaceEnabled = () => import.meta.env.VITE_QUOTE_WORKSPACE !== "off";
